var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { twoPxElevation } from "@irati/ui/src/global/elevation";
export var StyledImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var size = _a.size, noBorderRadius = _a.noBorderRadius;
    return "\n    width: " + size + "px;\n    height: " + size + "px;\n    border-radius: " + (noBorderRadius ? "unset" : size + "px") + ";\n  ";
});
export var ImageContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  ",
    "\n"
    // We need this as we need to absolute the inner and flex box doesn't like it
])), function (_a) {
    var size = _a.size;
    return "\n    height: " + (size / 2 - 5) + "px;\n  ";
});
// We need this as we need to absolute the inner and flex box doesn't like it
export var OuterContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var size = _a.size;
    return "\n    width: " + size + "px;\n  ";
});
export var ImageBorder = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n\n  ", "\n"], ["\n  position: absolute;\n\n  ",
    "\n"])), function (_a) {
    var size = _a.size, border = _a.border, alignLeft = _a.alignLeft, theme = _a.theme, backgroundColor = _a.backgroundColor;
    return "\n    background-color: " + (backgroundColor || "white") + ";\n    top: -" + (size / 2 + 5) + "px;\n    width: " + size + "px;\n    height: " + size + "px;\n    border-radius: " + size + "px;\n    padding: " + border / 2 + "px;\n    " + (alignLeft ? "left: " + theme.spacing.five + ";" : "") + "\n  ";
});
export var ProfileContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  ",
    "\n"])), function (_a) {
    var size = _a.size;
    return "\n    height: " + (size / 2 - 5) + "px;\n  ";
});
export var ProfileBorder = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  background-color: white;\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  background-color: white;\n  ", "\n\n  ",
    "\n"])), twoPxElevation, function (_a) {
    var size = _a.size, border = _a.border;
    return "\n    top: -" + (size / 2 + 5) + "px;\n    width: " + size + "px;\n    height: " + size + "px;\n    border-radius: " + size + "px;\n    padding: " + border / 2 + "px;\n  ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
